var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 56,
    viewBox: "0 0 63 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 63,
    height: 56,
    transform: "matrix(-1 0 0 1 63 0)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_13082",
    transform: "matrix(0.00925926 0 0 0.0104167 0.0555556 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_13082",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADPElEQVR4nO2cy2oUQRSGPxeSKFF0ISQICmqCeAmoK+/gM2hMwBcQUXHvfaEQssnGS2IeQXwBXSiYSHAhuIm6MN7QJBvFieYClhSpwXEMIeN096me/j/4NzMhp89/eqq7+lQ1CCGEEEIIIYQQQggRH2uBHmAQGAUmgbmgyfDZANANrLE+2EaiAxgCpgG3TPm/vQe0Wx98nlkF9AHzNRhfLf/r6AWarZPJG+3AyzqMr9YI0GadVF7YE8Z0l7A+AJ3WyeXhzJ9MwfzKIrRaJxkrzcCLFM0v63m4vogq+jIwv6xr1cGLTkeddzu16ruGor8ZytD8sm4ZnWxRznCnDQpQ0ox5gR4D88s6GY6h0AwaFuCudfIxMGpYAD9DLjxThgWYKLz7wKxhAWZUAFQAa6Y0BNkyqouwLQOGBbhjnHsUdBsW4IR18jHQEh4LZG1+KcQWLDTQsy6AH/pERSdsLkPz/dxjSzm4WKA3wwLcDDFFVUtyJAPzh4GmysDiD75h/j5F8z8BGyviiUXoDKsXkjbfF3b3YgHFv2wAHic87Gg5So00hdULpTrvdm5ozK+P1tBAr6UQpdDt0q1mgrSEHq5/fvMsNFNmgybCZ7eBLs1whRBCCCGEEEIIIYQQUT/7PwLsyiCW74odVo8A9gGXgEfAj/Ac/zOwKUXzNwNfQiwf8yFwEdhLQdgJXAVeLdFMeQtsTcn8N0vEHQf6gUPAChqI9cAF4HUNHa2PwIEEj+Fg+J/LjT8GnAfWkWO2hyWH/7sFdS70hOt5rcBq4Hodm8BLYQmj30ieG9pCPzapne/jwNka24z+jVnngHcJHcN8aHdGvbJiJXAlxZXOJeA+cBrYH8xoDmoNQ5b/7kGKG7/9MVwOuUaFv8A9TSlpF6H8rp5tRIJfqfAtAlNcxvoKHLc2398p/IrADGckn/sZK/O7Cm6+qyjCKYsJ1UwEybtI9BPYkWUBhiNI2kWmJ1mZfyyCZF2kOtqob7dyOVEmG/9qeaZTNI1lUQCL14u5nMjPlFPHOkkXuVQAVADzs9DpF2BvhNMQZG+GM5CuAagA5meh0y/A3ginIcjeDGcgXQNo8AIIIYQQQgghhBBCCHLJb/bnPNZybY9WAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.605133be.svg";
export { ForwardRef as ReactComponent };